module.exports = __webpack_public_path__ + "img/more-horizontal.654caee2.svg";